import { useContext, useState } from "react";
import AppContext from "../../contexts/AppContext";
import { ApiName, ApiRequest, getApiUrl } from "../api";

export function useApi(apiName?: ApiName) {
  const appContext = useContext(AppContext);

  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  async function process(request: ApiRequest): Promise<any> {
    try {
      setIsProcessing(true);
      const res = await fetch(`${getApiUrl(apiName)}/${request.path}`, {
        method: request.type,
        headers: getHeaders(appContext.login?.uid),
        body: JSON.stringify(request.payload),
      });
      const data = await res.json();
      return data;
    } catch (err: any) {
      appContext.setNotification({ type: "error", text: err.message });
      return null;
    } finally {
      setIsProcessing(false);
    }
  }

  return { process, isProcessing };
}

function getHeaders(auth?: string) {
  const headers = new Headers();
  // headers.append("Content-Type", "application/json");
  if (auth) {
    headers.append("Auth0-User", auth);
  }
  return headers;
}
